import qs from 'qs'
import axios from 'axios'
import * as login from './login'
import * as product from './product'
import * as scrmMarket from './scrmMarket'
import Vue from 'vue'
import { Toast } from 'vant'
import md5 from 'js-md5'
Toast.allowMultiple()
Vue.use(Toast)
const env = process.env.NODE_ENV
const getUrlCode = function (code) {
  const search = window.location.search.substr(1)
  const rag = RegExp('(^|&)' + code + '=([^&]*)(&|$)', 'i')
  const result = search.match(rag)
  return result ? result[2] : null
}
function getSign (res, isSignFrom, headers) {
  let params = JSON.parse(JSON.stringify(res.params || {}))
  let data = JSON.parse(JSON.stringify(res.data || {}))
  let param = {}
  if (res.method === 'POST') {
    param.body = data
  } else {
    param = params || {}
  }
  if (isSignFrom === 'scrmMarket') {
    param.accessid = 'scrmact'
    if (headers.ccToken) {
      param.ccToken = headers.ccToken
    }
    return strToMd5(param, (env === 'production' && location.href.indexOf('beta') === -1) ? 'AAF45EAD61D9DEE9' : '3441C13A1FC279F2')
  }
}
function strToMd5 (params, key) {
  // console.log('strToMd5', params, key)
  const str = setParams(params)
  return md5(str + key)
}
// function isEmptyObject(e) {
//   var t
//   for(t in e)
//     return !1
//   return !0
// }
function setParams (params) {
  // if (isEmptyObject(params)) {
  //   return ''
  // } else {
  var str = Object.keys(params).sort().map(key => {
    const val = params[key]
    let value = key + '=' + val
    if (typeof val !== 'string') {
      value = key + '=' + JSON.stringify(val)
    }
    return value
  }).join('&')
  return str
  // }
}
const service = {
  state: {
    inited: false,
    user: null
  },
  init(cb) {
    cb()
  },
  fetch({
    method = 'get',
    url,
    isReturntype = 0,
    scope = 'snsapi_base',
    data,
    params,
    isJSON = true,
    isState = true,
    platformCode = false,
    isShowError = true,
    isSign = false,
    isSignFrom,
    isJDK = false,
    headers = {}
  }) {
    let defaultLoading
    if (isState) {
      defaultLoading = Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 10000
      })
    }

    // url = process.env.VUE_APP_TITLE === 'production' ? `/${url}` : `/${url}`
    const options = {
      method,
      url,
      isReturntype: isReturntype,
      data: isJSON ? data : typeof data === 'string' ? data : qs.stringify(data),
      scope: scope,
      params,
      isState
    }
    options.headers = headers
    if (isSign) {
      let sign
      if (isSignFrom === 'JDK') {
        sign = strToMd5(JSON.parse(data.param), '8762b394068d4412c8dac7883228d5ec')
        options.data += '&client_id=minipro2019&sign=' + sign
      } else {
        sign = getSign(options, isSignFrom, headers)
        if (isSignFrom === 'scrmMarket') {
          options.url += '?accessid=scrmact&sign=' + sign
        }
      }
    }
    if (platformCode) {
      const parameter = options.method === 'GET' ? 'params' : 'data'
      let data = options.method === 'GET' ? JSON.parse(JSON.stringify(options.params || {})) : JSON.parse(JSON.stringify(options.data || {}))
      data.platformCode = data.platformCode || '0003'
      options[parameter] = data
    }
    const handleResponse = (result) => {
      const data = result.data
      if (defaultLoading) {
        defaultLoading.clear()
      }
      if (isJDK && data.returnCode === '200') { // jdk接口请求成功
        return data
      }
      // isReturntype === 1 除帐号信息失效不返回其它都返回 code 400101 400102  400103
      // isReturntype === 2 所有状态都正常返回业务端
      // isReturntype === 0 只有200正常返回
      if ((options.isReturntype === 1 && data.code !== 400101 && data.code !== 400102 && data.code !== 400103) || options.isReturntype === 2) {
        return data
      } else {
        if (!isShowError) {
          return
        } else if (data.code !== 200 && data.code !== 0) {
          if (data.code === 400101 || data.code === 400201) {
            let url = encodeURIComponent(window.location.href)
            let defalutCode = null
            if (data.code === 400101) {
              defalutCode = getUrlCode('code')
            }
            return this.getToken().then(res => {
              if (defalutCode) {
                return this.accredit({
                  appId: res.data.appId,
                  code: defalutCode,
                  scope: options.scope
                }).then(() => {
                  return axios(options).then(handleResponse)
                })
              } else {
                const wxurl = `http://wx.coocaa.com/weixin.htm?appid=${res.data.appId}&redirect_uri=${url}&scope=${options.scope}&state=`
                window.location.href = wxurl
              }
            })
          }
          throw result
        }
        return data.data || data
      }
    }
    return axios(options).then(handleResponse)
  },
  ...login,
  ...product,
  ...scrmMarket
}

export default service
